import React, {Component} from 'react';
import {injectIntl, FormattedMessage} from 'react-intl';
import {List} from 'immutable';
import {withRouter} from 'react-router-dom';
import {EditorState, ContentBlock, genKey, convertFromRaw, convertToRaw, Modifier} from 'draft-js';
import RichTextField from '../components/new-ui/rich_text_field';
import DatePickerV3 from '../forecast-app/shared/components/date-picker/date_picker_v3';
import {DATE_PICKER_STYLE, BUTTON_STYLE, BUTTON_COLOR, companyLogoSrc, ESTIMATION_UNIT} from '../constants';
import InputField from '../components/new-ui/input_field';
import Button from '../forecast-app/shared/components/buttons/button/button';
import UploadingOverlay from '../forecast-app/shared/components/uploading-overlay/uploading_overlay';
import {createToast} from '../forecast-app/shared/components/toasts/another-toast/toaster';
import {MODAL_TYPE, showModal} from '../forecast-app/shared/components/modals/generic_modal_conductor';
import HoursInput from '../forecast-app/shared/components/inputs/hours-input/hours_input_view';
import * as tracking from '../tracking';
import Util from '../forecast-app/shared/util/util';
class PublicCreateTaskPageOld extends Component {
	constructor(props) {
		super(props);
		this.fetchRequiredData();
		this.state = this.getFreshStateObject();
		this.props.setLocaleFromBrowser();
	}

	componentDidMount() {
		tracking.trackPage('public-create-task');
	}

	async fetchRequiredData() {
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		const init = {headers, method: 'GET'};
		const linkToPublicCreateTaskPage = this.props.match.params && this.props.match.params.linkToPublicCreateTaskPage ? this.props.match.params.linkToPublicCreateTaskPage : null;
		let requestUrl = `${process.env.GRAPHQL_ENDPOINT.slice(0, -7)}public_create_task_page/${linkToPublicCreateTaskPage}/no_password`;
		return await fetch(requestUrl, init)
			.then(response => {
				return response.json();
			})
			.then(data => {
				if (!data.projectId) {
					this.props.history.push('/login');
				}
				this.setState({
					companyName: data.companyName,
					companyLogoId: data.companyLogoId,
					projectId: data.projectId,
					statusColumnId: data.statusColumnId,
					projectEstimationUnit: data.projectEstimationUnit,
				});
				return data;
			})
			.catch(error => {
				if (!('' + error).includes('abort')) {
					throw error;
				}
				this.props.history.push('/login');
			});
	}

	handleTaskNameChange(value) {
		this.setState({taskName: value});
	}
	handleTaskDescriptionChange(editorState) {
		this.setState({taskDescription: editorState});
	}
	handleCreatorsCompanyNameChange(value) {
		this.setState({creatorsCompanyName: value});
	}
	habdleCreatorsCompanyMailChange(value) {
		this.setState({creatorsCompanyMail: value});
	}
	handleTaskDeadlineChange(date) {
		this.setState({taskDeadline: date});
	}
	handleTaskLowEstimateChange(value) {
		this.setState({taskLowEstimate: value});
	}
	handleTaskHighEstimateChange(value) {
		this.setState({taskHighEstimate: value});
	}
	createNewBlock(message) {
		return new ContentBlock({
			key: genKey(),
			type: 'unstyled',
			text: message,
			characterList: List(),
		});
	}
	getFreshStateObject() {
		return {
			uploading: false,
			taskName: '',
			taskDescription: null,
			taskDeadline: null,
			taskLowEstimate: 0,
			taskHighEstimate: 0,
			creatorsCompanyName: '',
			creatorsCompanyMail: '',
			uploadFiles: null,
		};
	}
	prepareDescription() {
		const content = this.state.taskDescription ? convertFromRaw(JSON.parse(this.state.taskDescription)) : null;
		const editorState = content ? EditorState.createWithContent(content) : EditorState.createEmpty();
		const contentState = editorState.getCurrentContent();
		const selection = editorState.getSelection();

		let text = `Company Name: ${this.state.creatorsCompanyName}\nCompany Email: ${this.state.creatorsCompanyMail}\n`;
		if (this.state.taskDeadline) {
			text += `Requested Task End Date: ${this.state.taskDeadline.format('DD/MMM/YYYY')}\n`;
		}
		let lowValue;
		let highValue;
		if (this.state.projectEstimationUnit === ESTIMATION_UNIT.HOURS) {
			lowValue = Util.convertMinutesToFullHour(this.state.taskLowEstimate * 60, this.props.intl, true);
			highValue = Util.convertMinutesToFullHour(this.state.taskHighEstimate * 60, this.props.intl, true);
		} else {
			const suffix = this.state.projectEstimationUnit === ESTIMATION_UNIT.POINTS ? 'p' : undefined;
			lowValue = this.state.taskLowEstimate + suffix;
			highValue = this.state.taskHighEstimate + suffix;
		}

		if (this.state.taskLowEstimate !== undefined && this.state.taskLowEstimate !== null) {
			text += 'Requested low estimate:' + lowValue + '\n';
		}
		if (this.state.taskHighEstimate !== undefined && this.state.taskHighEstimate !== null) {
			text += 'Requested high estimate: ' + highValue + '\n';
		}
		let newContentState = Modifier.insertText(contentState, selection, text);
		let newEditorState = EditorState.push(editorState, newContentState, 'insert-fragment');
		return JSON.stringify(convertToRaw(newEditorState.getCurrentContent()));
	}
	handleFileSelect() {
		if (this.uploadFiles && this.uploadFiles.files) {
			const files = this.state.uploadFiles ? this.state.uploadFiles : [];
			for (let i = 0; i < this.uploadFiles.files.length; i++) {
				files.push(this.uploadFiles.files[i]);
			}
			this.setState({uploadFiles: files});
		}
	}
	showValidationErrorModal(warning) {
		showModal({
			type: MODAL_TYPE.GENERIC,
			content: warning,
			className: 'default-warning-modal',
			buttons: [
				{
					text: 'OK',
					style: BUTTON_STYLE.FILLED,
					color: BUTTON_COLOR.WHITE,
				},
			],
		});
	}
	async handleCreateTask() {
		const estimatesValid =
			(!this.state.taskHighEstimate && !this.state.taskLowEstimate) ||
			(this.state.taskLowEstimate && this.state.taskHighEstimate && this.state.taskLowEstimate <= this.state.taskHighEstimate) ||
			(this.state.taskHighEstimate && !this.state.taskLowEstimate);
		const requiredFieldsProvided = this.state.projectId && this.state.statusColumnId && this.state.taskName && this.state.creatorsCompanyName && this.state.creatorsCompanyMail;
		const emailValid = this.state.creatorsCompanyMail && /(.+)@(.+)\.(.+)/.test(this.state.creatorsCompanyMail);
		if (!estimatesValid || !requiredFieldsProvided || !emailValid) {
			return;
		}
		this.setState({uploading: true});
		const formData = new FormData();
		const description = this.prepareDescription();
		formData.append('name', this.state.taskName);
		formData.append('projectId', this.state.projectId);
		formData.append('statusColumnId', this.state.statusColumnId);
		formData.append('description', description);
		if (this.state.uploadFiles) {
			for (let i = 0; i < this.state.uploadFiles.length; i++) {
				formData.append('uploadFiles', this.state.uploadFiles[i]);
			}
		}
		const headers = new Headers();
		const init = {headers, method: 'POST', body: formData};
		const linkToPublicCreateTaskPage = this.props.match.params && this.props.match.params.linkToPublicCreateTaskPage ? this.props.match.params.linkToPublicCreateTaskPage : null;
		let requestUrl = `${process.env.GRAPHQL_ENDPOINT.slice(0, -7)}public_create_task_page/${linkToPublicCreateTaskPage}/no_password`;
		return await fetch(requestUrl, init)
			.then(response => {
				return response.json();
			})
			.then(data => {
				if (data.fileValidationError) {
					this.setState(this.getFreshStateObject());
					this.showValidationErrorModal(this.props.intl.formatMessage({id: `public_crete_task_form.${data.fileValidationError}_error`}));
				} else if (data.message === 'RATE_LIMIT') {
					this.setState(this.getFreshStateObject());
					this.showValidationErrorModal(<FormattedMessage id="login.rate_limit" />);
				} else {
					tracking.trackPageAction('Public task created');
					createToast({duration: 5000, message: this.props.intl.formatMessage({id: 'public_crete_task_form.submit_form_success_toast_text'})});
					this.setState(this.getFreshStateObject());
					return data;
				}
			})
			.catch(error => {
				if (!('' + error).includes('abort')) {
					throw error;
				}
			});
	}
	render() {
		const {formatMessage} = this.props.intl;
		const suffix = this.state.projectEstimationUnit === ESTIMATION_UNIT.POINTS ? 'p' : this.state.projectEstimationUnit === ESTIMATION_UNIT.HOURS ? 'h' : undefined;
		const invalidEstimates = this.state.taskHighEstimate < this.state.taskLowEstimate;
		const fileLimitReached = this.state.uploadFiles && this.state.uploadFiles.length >= 5;
		return (
			<div className="public-create-task-page">
				{this.state.uploading ? <UploadingOverlay /> : null}
				<div className="public-create-task-page-header">
					{this.state.companyLogoId ? <img src={companyLogoSrc(this.state.companyLogoId)} alt="company-logo" /> : null}
					<span className="company-name">{this.state.companyName}</span>
				</div>
				<div className="public-create-task-page-body">
					<div className="form-title">{formatMessage({id: 'public_crete_task_form.title'})}</div>
					<InputField required={true} type="text" onChange={this.handleTaskNameChange.bind(this)} value={this.state.taskName} label={formatMessage({id: 'common.name'})} />
					<div className="label-editor-wrapper">
						<span className="description-label">{formatMessage({id: 'common.description'})}</span>
						<RichTextField readOnly={false} alwaysShowControls={false} text={this.state.taskDescription} characterLimit={this.state.characterLimit} placeholder={''} handleTextChange={this.handleTaskDescriptionChange.bind(this)} />
					</div>
					<InputField required={true} type="text" label={formatMessage({id: 'public_crete_task_form.your_company_name'})} value={this.state.creatorsCompanyName} onChange={this.handleCreatorsCompanyNameChange.bind(this)} />
					<InputField
						required={true}
						type="text"
						label={formatMessage({id: 'public_crete_task_form.your_company_email'})}
						value={this.state.creatorsCompanyMail}
						onChange={this.habdleCreatorsCompanyMailChange.bind(this)}
						invalidInput={this.state.creatorsCompanyMail !== '' && !/(.+)@(.+)\.(.+)/.test(this.state.creatorsCompanyMail)}
					/>
					<div className="file-input-and-label-wrapper">
						<input className="public-create-task-form-file-input" type="file" ref={input => (this.uploadFiles = input)} id="uploadFiles" onChange={this.handleFileSelect.bind(this)} disabled={fileLimitReached} />
						<label className={'file-input-label' + (fileLimitReached ? ' disabled' : '')} htmlFor="uploadFiles">
							{formatMessage({id: 'task_modal.attach_computer_file'})}
						</label>
					</div>
					{this.state.uploadFiles
						? this.state.uploadFiles.map((uploadFile, index) => (
								<span className="public-task-form-file-to-upload-name" key={index}>
									{uploadFile.name}
								</span>
						  ))
						: null}
					<div className="date-picker-form-wrapper">
						<DatePickerV3 handleDateRangeChange={this.handleTaskDeadlineChange.bind(this)} datePickerStyle={DATE_PICKER_STYLE.STANDARD} isSingleDatePicker={true} label={formatMessage({id: 'common.end_date'})} />
					</div>
					{this.state.projectEstimationUnit === ESTIMATION_UNIT.HOURS ? (
						<div className="estimate-inputs-wrapper">
							<div className={'input-container-v2'}>
								<HoursInput hasError={invalidEstimates} label={formatMessage({id: 'common.low-estimate'})} value={this.state.taskLowEstimate} mutation={this.handleTaskLowEstimateChange.bind(this)}></HoursInput>
							</div>
							<div className="white-space"></div>
							<div className={'input-container-v2'}>
								<HoursInput invalidInput={invalidEstimates} label={formatMessage({id: 'common.high-estimate'})} value={this.state.taskHighEstimate} mutation={this.handleTaskHighEstimateChange.bind(this)}></HoursInput>
							</div>
						</div>
					) : (
						<div className="estimate-inputs-wrapper">
							<InputField type="number" invalidInput={invalidEstimates} label={formatMessage({id: 'common.low-estimate'})} value={this.state.taskLowEstimate} onChange={this.handleTaskLowEstimateChange.bind(this)} suffix={suffix} />
							<div className="white-space"></div>
							<InputField type="number" invalidInput={invalidEstimates} label={formatMessage({id: 'common.high-estimate'})} value={this.state.taskHighEstimate} onChange={this.handleTaskHighEstimateChange.bind(this)} suffix={suffix} />
						</div>
					)}
					<div className="submit-button-wrapper">
						<Button className="submit-button" text={formatMessage({id: 'common.add'})} buttonStyle={BUTTON_STYLE.FILLED} colorTheme={BUTTON_COLOR.GREEN} onClick={this.handleCreateTask.bind(this)} />
					</div>
				</div>
			</div>
		);
	}
}
export default injectIntl(withRouter(PublicCreateTaskPageOld));
